import { object } from 'common/helpers'


export const initialState = {
  user: {
    gender: 'female',
    firstName: 'Scentbird',
    lastName: '',
    avatar: null,
    subscription: {
      statusText: null,
    },
  },
  stats: {
    orders: 0,
    queue: 0,
    reviews: 0,
    ratedProducts: 0,
  },
  queue: {
    isFetching: false,
    items: [],
  },
  receivedProducts: {
    isFetching: false,
    items: [],
  },
  reviews: {
    isFetching: false,
    items: [],
  },
  ratedProducts: {
    isFetching: false,
    items: [],
  },
}


export const set = (state, payload) => (
  object.merge(state, payload)
)

export const setQueueFetching = (state, payload) => (
  object.setIn(state, [ 'queue', 'isFetching' ], payload)
)

export const setQueueItems = (state, payload) => (
  object.set(state, 'queue', { isFetching: false, items: payload })
)

export const setReceivedProductsFetching = (state, payload) => (
  object.setIn(state, [ 'receivedProducts', 'isFetching' ], payload)
)

export const setReceivedProducts = (state, payload) => (
  object.set(state, 'receivedProducts', { isFetching: false, items: payload })
)

export const setReviewsFetching = (state, payload) => (
  object.setIn(state, [ 'reviews', 'isFetching' ], payload)
)

export const setReviews = (state, payload) => (
  object.set(state, 'reviews', { isFetching: false, items: payload })
)

export const setRatedProductsFetching = (state, payload) => (
  object.setIn(state, [ 'ratedProducts', 'isFetching' ], payload)
)

export const setRatedProducts = (state, payload) => (
  object.set(state, 'ratedProducts', { isFetching: false, items: payload })
)
